import React, { Component } from "react";
import {
    Table,
    message,
    Form,
    Select,
    Tag,
    Button,
    Modal,
    Upload,
    Radio
} from "antd";
import { UploadOutlined } from "@ant-design/icons";
import {
    partnerList,
    update,
    deletePartner,
    contractList,
    updatePartner
} from "@api/partnerManage";
import moment from "moment";
import FormSummary from "@components/FormSummary";
import ConfigForm from "./components/Config";
import url from "@utils/url";
import { Object } from "core-js";
import { store } from "../store-manager";
import { getChannelByLvl } from "@api/user";

let fileList = [];
let actionType = "";
const confirm = Modal.confirm;
const { Option } = Select;
const { HOST } = url;
const [
    AuditStatusDefault,
    AuditStatusPass,
    AuditStatusReject,
    AuditStatusCanSettle,
    AuditStatusForbidden,
    AuditStatusDeleted
] = [0, 1, 2, 3, 4, 5];

console.log(AuditStatusReject, AuditStatusForbidden, AuditStatusDeleted);

const dateFormat = "YYYY/MM/DD hh:mm:ss";
const config = {
    0: { name: "未审核", color: "#409EFF", border: "#B3D8FF" },
    1: { name: "审核通过", color: "#606266", border: "#DCDFE6" },
    2: { name: "审核拒接", color: "#606266", border: "#DCDFE6" },
    3: { name: "可结算", color: "#67C23A", border: "#D3E7CE" },
    4: { name: "禁用", color: "#F56C6C", border: "#F0D7DA" }
};
let channels = [];
// let allChannels = [];
let pastInfo = { parentId: "", contractUrl: [], isNewCreateChannel: false };
let allFormItems = [
    {
        key: "name",
        label: "合作方名称",
        require: true,
        componentName: "input",
        disabled: true
    },
    {
        key: "contact",
        label: "联系人",
        require: true,
        componentName: "input",
        disabled: true
    },
    {
        key: "mobile",
        label: "手机号",
        require: true,
        componentName: "input",
        disabled: true
    },
    {
        key: "address",
        label: "通讯地址",
        require: true,
        componentName: "input",
        disabled: true
    },
    {
        key: "licenseUrl",
        label: "营业执照",
        require: true,
        componentName: "upload",
        uploadUrl: `${HOST}/cps-gateway/api/v1/partner/img/upload`,
        disabled: true
    },
    {
        key: "taxNumber",
        label: "税号",
        require: true,
        componentName: "input",
        disabled: true
    },
    {
        key: "bankName",
        label: "开户行",
        require: true,
        componentName: "input",
        disabled: true
    },
    {
        key: "bankAccountName",
        label: "开户名",
        require: true,
        componentName: "input",
        disabled: true
    },
    {
        key: "bankAccount",
        label: "账户名称",
        require: true,
        componentName: "input",
        disabled: true
    }
    // {
    //     key: "cooperateType",
    //     label: "合作方式",
    //     require: true,
    //     componentName: "select",
    //     disabled: true,
    //     options: []
    // },
    // {
    //     key: "cooperatePrice",
    //     label: "合作价格(单位分)",
    //     require: true,
    //     componentName: "input",
    //     disabled: true
    // },
    // {
    //     key: "reward",
    //     label: "分成比例(%)",
    //     require: true,
    //     componentName: "input",
    //     disabled: true
    // }
];

export default class PartnerManage extends Component {
    formRef = React.createRef();

    state = {
        pagination: {
            page: 1,
            size: 10,
            total: 0
        },
        visible: false,
        configVisible: false,
        pastVisible: false,
        formItems: allFormItems,
        formDefaultValue: {},
        allSelect: [
            {
                key: "auditStatus",
                placeholder: "选择审核状态",
                defaultValue: "",
                options: [
                    { value: "", label: "全部" },
                    { value: "0", label: "未审核" },
                    { value: "1", label: "审核通过" },
                    { value: "2", label: "审核拒接" },
                    { value: "3", label: "可结算" },
                    { value: "4", label: "禁用" }
                ],
                title: "审核状态"
            },
            {
                key: "cooperateType",
                // mode: "multiple",
                placeholder: "选择合作方式",
                defaultValue: "",
                options: [
                    { value: "", label: "全部" }
                    // { value: "cps", label: "CPS" },
                    // { value: "cpa", label: "CPA" },
                ],
                title: "合作方式"
            }
        ],
        selectedVal: { auditStatus: "", cooperateType: "" },
        configData: {},
        isNewCreateChannel: false,
        secondChannels: [],
        secondChannelId: ''
    };

    componentWillMount() {
        this.getContractList();
    }

    componentDidMount() {
        this.getPartnerList({ page: 1, size: 10 });
        this.getChannelsList();
    }

    handleSelectChange = (value, key) => {
        const { selectedVal } = this.state;

        selectedVal[key] = value;
        this.setState({ selectedVal });
    };

    getContractList = async () => {
        const res = await contractList();

        if (res.data.meta.errCode !== 0) {
            message.error(res.data.meta.errMsg);
            return;
        }

        const { allSelect } = this.state;
        const list = res.data.data.list || [];
        const tempOptions = list.map(item => ({
            value: item.contractType,
            label: item.contractType
        }));

        allSelect[1].options = [{ label: "全部", value: "" }].concat(
            tempOptions
        );

        this.setState({ typeList: tempOptions });

        // const tempItem = allFormItems.find(
        //     item => item.key === "cooperateType"
        // );
        // tempItem.options = tempOptions;
        // tempItem.onChange = this.selectChange;
    };

    selectChange = type => {
        const notNeedItem = type === "cpa" ? "reward" : "cooperatePrice";
        const tempFormItems = allFormItems.filter(item => {
            return item.key !== notNeedItem;
        });

        this.setState({ formItems: tempFormItems });
    };

    getPartnerList = async params => {
        const { selectedVal } = this.state;
        const res = await partnerList({ ...params, ...selectedVal });

        if (res.data.meta.errCode !== 0) {
            message.error(res.data.meta.errMsg);
            return;
        }

        const paging = res.data.meta.paging || {};

        this.setState({
            pagination: { ...paging },
            tableData: res.data.data.list || []
        });
    };

    getFirstChannel = async () => {
        const ret = await getChannelByLvl(1)
        if (ret && ret.data && ret.data.data) {
            const resp = ret.data.data || []
            store.sync({
                firstChannel: resp
            })
            console.log('all first channel: ', resp);
        }
    }

    getSecondChanelById = async (parentId) => {
        const ret = await getChannelByLvl(2, parentId)
        if (ret && ret.data && ret.data.data) {
            const resp = ret.data.data || []
            console.log('all second channel: ', resp);
            store.sync({
                secondChannel: resp
            })
        }
    }

    getThirdChannelById = async (parentId) => {
        const ret = await getChannelByLvl(3, parentId)
        if (ret && ret.data && ret.data.data) {
            const resp = ret.data.data || []
            console.log('all third channel: ', resp);
            store.sync({
                thirdChannel: resp
            })
        }
    }

    getChannelsList = async () => {
        if (true) {
            await this.getFirstChannel()
            const res = store.remote.firstChannel
            let tempData = res || [];
            // allChannels = tempData;
            channels = tempData.map(item => ({ label: item.name, value: item.id }));
        } else {
            await store.hasAllChannel()
            const res = store.remote.channel

            let tempData = res || [];

            // allChannels = tempData;
            channels = tempData.map(item => ({ label: item.name, value: item.id }));
        }
    };

    changePage = page => {
        const params = {
            page: page.current,
            size: 10
        };

        this.getPartnerList(params);
    };

    handleDateFormat = timestamp => {
        return timestamp
            ? moment(new Date(timestamp * 1000)).format(dateFormat)
            : "---";
    };

    handleSearch = () => {
        const params = {
            page: 1,
            size: 10
        };

        this.getPartnerList(params);
    };
    handleChange = () => {
        this.getPartnerList({
            page: this.state.pagination.page,
            size: 10
        });
    };
    getCurrentStatus = status => {
        return (
            <Tag
                style={{
                    cursor: "default",
                    background: "#fff",
                    borderColor: config[status].border,
                    color: config[status].color
                }}
            >
                {config[status].name}
            </Tag>
        );
    };

    goUrl = () => {
        const url = `${window.location.origin}/#/signin`;

        window.open(url);
    };

    handleCancle = () => {
        this.setState({ visible: false });
    };

    handleCooperationConfig = data => {
        this.setState({ configData: data });
        this.setState({ configVisible: true });
    };

    handleReview = (data, type) => {
        let tempData = JSON.parse(JSON.stringify(data));

        actionType = type;
        const notNeedItem =
            tempData.cooperateType === "cpa" ? "reward" : "cooperatePrice";
        const tempFormItems = allFormItems.filter(item => {
            if (type === "edit") {
                item.disabled = false;
            } else {
                item.disabled = true;
            }

            return item.key !== notNeedItem;
        });

        if (actionType === "edit") {
            pastInfo.contractUrl = [];
            let list = tempData.contractUrl || [];

            fileList = list.map((item, index) => {
                let tempUrl = decodeURI(item);

                pastInfo.contractUrl.push(item);

                return {
                    uid: index,
                    name: tempUrl.substring(tempUrl.lastIndexOf("/") + 1),
                    url: tempUrl,
                    response: { data: tempUrl }
                };
            });
        }

        this.setState(
            {
                formItems: tempFormItems,
                currentId: tempData.id,
                currentStatus: tempData.auditStatus,
                formDefaultValue: tempData
            },
            () => {
                this.setState({ visible: true });
            }
        );
    };

    handleUpdate = async () => {
        let form = this.formRef.current;

        try {
            const values = await form.validateFields();

            const { formDefaultValue } = this.state;
            const params = {
                id: this.state.currentId,
                ...values,
                contractUrl: pastInfo.contractUrl,
                cooperateType: formDefaultValue.cooperateType
            };

            if (formDefaultValue.cooperatePrice) {
                params.cooperatePrice = Number(formDefaultValue.cooperatePrice);
            }
            if (formDefaultValue.reward) {
                params.reward = Number(formDefaultValue.reward);
            }
            if (values.licenseUrl && values.licenseUrl.file) {
                params.licenseUrl = values.licenseUrl.file.response.data;
            }

            const res = await updatePartner(params);
            if (res.data.meta.errCode !== 0) {
                message.error(res.data.meta.errMsg);
                return;
            }

            message.success("更新成功!");
            this.getPartnerList({
                page: this.state.pagination.page,
                size: 10
            });
            this.setState({ visible: false });
        } catch (err) {
            console.log(err);
        }
    };

    getStatusBtns = () => {
        const tempStatus = this.state.currentStatus;
        let template = "";

        if (tempStatus === AuditStatusDefault) {
            template = (
                <span>
                    <Button type="primary" onClick={this.handlePast}>
                        通过
                    </Button>
                    <Button
                        type="danger"
                        onClick={this.handleRefuse}
                        style={{ marginLeft: 10 }}
                    >
                        拒绝
                    </Button>
                </span>
            );
        }

        if (tempStatus === AuditStatusPass) {
            template = (
                <span>
                    <Button type="primary" onClick={this.handleAccount}>
                        可结算
                    </Button>
                    <Button
                        type="danger"
                        onClick={this.handleDisable}
                        style={{ marginLeft: 10 }}
                    >
                        禁用
                    </Button>
                </span>
            );
        }

        if (tempStatus === AuditStatusCanSettle) {
            template = (
                <span>
                    <Button
                        type="danger"
                        onClick={this.handleDisable}
                        style={{ marginLeft: 10 }}
                    >
                        禁用
                    </Button>
                </span>
            );
        }

        if (actionType === "edit") {
            template = (
                <span>
                    <Button type="primary" onClick={this.handleUpdate}>
                        更新
                    </Button>
                </span>
            );
        }

        return template;
    };

    handleAccount = () => {
        let _this = this;

        confirm({
            title: "您确认可结算嘛?",
            content: "",
            onOk() {
                const params = {
                    auditStatus: 3,
                    id: _this.state.currentId
                };

                update(params).then(res => {
                    if (res.data.meta.errCode !== 0) {
                        message.error(res.data.meta.errMsg);
                        return;
                    }
                    message.success("可结算成功!");
                    _this.handlePastCancle();
                    _this.setState({ visible: false });
                    _this.handleChange("");
                });
            }
        });
    };

    handleDisable = () => {
        let _this = this;

        confirm({
            title: "您确认禁用嘛?",
            content: "",
            onOk() {
                const params = {
                    auditStatus: 4,
                    id: _this.state.currentId
                };

                update(params).then(res => {
                    if (res.data.meta.errCode !== 0) {
                        message.error(res.data.meta.errMsg);
                        return;
                    }
                    message.success("禁用成功!");
                    _this.handlePastCancle();
                    _this.setState({ visible: false });
                    _this.handleChange("");
                });
            }
        });
    };

    handlePast = () => {
        this.setState({ pastVisible: true });
    };

    handleRefuse = () => {
        let _this = this;

        confirm({
            title: "您确认拒绝嘛?",
            content: "",
            onOk() {
                const params = {
                    auditStatus: 2,
                    id: _this.state.currentId
                };

                update(params).then(res => {
                    if (res.data.meta.errCode !== 0) {
                        message.error(res.data.meta.errMsg);
                        return;
                    }
                    message.success("拒绝成功!");
                    _this.handlePastCancle();
                    _this.setState({ visible: false });
                    _this.handleChange("");
                });
            }
        });
    };

    handlePastCancle = () => {
        pastInfo = { parentId: "", contractUrl: [], isNewCreateChannel: false };
        this.setState({ pastVisible: false });
    };

    handlePastOk = async () => {
        const { currentStatus } = this.state;
        let nextStatus = 1;

        if (currentStatus === 0) {
            if (pastInfo.parentId === "") {
                message.error("请选一级渠道");
                return;
            }
        } else {
            nextStatus = 3;
            if (pastInfo.contractUrl.length === 0) {
                message.error("请上传文件");
                return;
            }
        }

        const params = {
            auditStatus: nextStatus,
            id: this.state.currentId,
            ...pastInfo
        };
        const res = await update(params);

        if (res.data.meta.errCode !== 0) {
            message.error(res.data.meta.errMsg);
            return;
        }
        message.success("通过成功!");
        this.handlePastCancle();
        this.setState({ visible: false });
        this.handleChange("");
    };

    getUploadUrl = () => {
        return `${HOST}/cps-gateway/api/v1/partner/img/upload`;
    };

    handleUploadChange = info => {
        // done error removed
        if (info.file.status === "done" || info.file.status === "removed") {
            pastInfo.contractUrl = info.fileList.map(
                item => item.response.data
            );
        }
        if (info.file.status === "error") {
            message.error("上传文件失败!");
        }
    };
    handleChannelChange = async val => {
        pastInfo.parentId = val;
        pastInfo.secondChannelId = '';
        await this.getSecondChanelById(val)
        // const secondChannels = (allChannels.find(i => i.id === val) || {}).sub || [];
        const secondChannels = store.remote.secondChannel
        this.setState({ secondChannels, secondChannelId: '' });
    };
    handleSecondChannelChange = val => {
        pastInfo.secondChannelId = val;
        this.setState({ secondChannelId: val });
    };
    onRadioChange = e => {
        pastInfo.isNewCreateChannel = e.target.value;
        delete pastInfo.secondChannelId;
        this.setState({ isNewCreateChannel: pastInfo.isNewCreateChannel, secondChannelId: '' })
    };
    isCanDelete = data => {
        if (
            data.auditStatus === AuditStatusPass ||
            data.auditStatus === AuditStatusCanSettle
        ) {
            return true;
        }
        return false;
    };

    handleDelete = data => {
        let _this = this;

        confirm({
            title: `您确认删除合作方${data.name}嘛?`,
            content: "",
            onOk() {
                const params = {
                    id: data.id
                };

                deletePartner(params).then(res => {
                    if (res.data.meta.errCode !== 0) {
                        message.error(res.data.meta.errMsg);
                        return;
                    }
                    message.success("删除成功!");
                    _this.handleChange("");
                });
            }
        });
    };

    saveCallBack = data => {
        const { configData } = this.state;
        const params = Object.assign(configData, data);

        updatePartner(params).then(res => {
            if (res.data.meta.errCode !== 0) {
                message.error(res.data.meta.errMsg);
                return;
            }

            message.success("配置成功!");
            this.getPartnerList({
                page: this.state.pagination.page,
                size: 10
            });
            this.setState({ configVisible: false });
        });
    }

    render() {
        const columns = [
            {
                title: "创建时间",
                dataIndex: "createdAt",
                align: "center",
                render: (text, record, index) => {
                    return <span>{this.handleDateFormat(text)}</span>;
                },
                width: 120
            },
            {
                title: "合作方名称",
                dataIndex: "name",
                align: "center"
            },
            {
                title: "联系人",
                dataIndex: "contact",
                align: "center"
            },
            {
                title: "手机号",
                dataIndex: "mobile",
                align: "center"
            },
            {
                title: "营业执照",
                dataIndex: "licenseUrl",
                align: "center",
                render: text => {
                    return (
                        <a
                            href={text}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img
                                src={text}
                                alt="img"
                                style={{
                                    width: 50,
                                    height: 50,
                                    cursor: "pointer"
                                }}
                            />
                        </a>
                    );
                }
            },
            {
                title: "合作方式",
                dataIndex: "cooperateType",
                align: "center"
            },
            {
                title: "审核状态",
                dataIndex: "auditStatus",
                align: "center",
                render: (text, record, index) => {
                    return this.getCurrentStatus(text);
                }
            },
            {
                title: "操作",
                dataIndex: "",
                align: "center",
                width: 300,
                render: (text, record, index) => {
                    return (
                        <span>
                            <Button
                                type="primary"
                                size="small"
                                onClick={() => {
                                    this.handleReview(record, "detail");
                                }}
                            >
                                详情
                            </Button>
                            <Button
                                style={{ marginLeft: 8 }}
                                type="primary"
                                size="small"
                                onClick={() => {
                                    this.handleCooperationConfig(record);
                                }}
                            >
                                合作配置
                            </Button>
                            <Button
                                style={{ marginLeft: 8 }}
                                type="primary"
                                size="small"
                                onClick={() => {
                                    this.handleReview(record, "edit");
                                }}
                            >
                                编辑
                            </Button>
                            <Button
                                style={{ marginLeft: 8 }}
                                disabled={this.isCanDelete(record)}
                                type="danger"
                                size="small"
                                onClick={() => {
                                    this.handleDelete(record);
                                }}
                            >
                                删除
                            </Button>
                        </span>
                    );
                }
            }
        ];

        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 6 }
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 17, offset: 1 }
            }
        };
        const contractItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 6 }
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 17, offset: 0 }
            }
        };
        const {
            allSelect,
            configVisible,
            currentStatus,
            typeList,
            configData,
            isNewCreateChannel,
            secondChannels,
            secondChannelId
        } = this.state;

        return (
            <div>
                <h2 style={{ marginTop: 8 }}>合作方管理</h2>
                <ul style={{ overflow: "hidden", marginTop: 30 }}>
                    {allSelect.map(item => {
                        return (
                            <li
                                key={item.key}
                                style={{
                                    float: "left",
                                    width: 250,
                                    marginRight: 20
                                }}
                            >
                                <span style={{ lineHeight: "32px" }}>
                                    {item.title}
                                </span>
                                <Select
                                    optionFilterProp="children"
                                    allowClear={false}
                                    maxTagCount={1}
                                    mode={item.mode || ""}
                                    placeholder={item.placeholder}
                                    defaultValue={item.defaultValue}
                                    onChange={value => {
                                        this.handleSelectChange(
                                            value,
                                            item.key
                                        );
                                    }}
                                    style={{ width: "75%", float: "right" }}
                                    showSearch
                                >
                                    {item.options.map(ele => {
                                        return (
                                            <Option
                                                key={ele.value}
                                                value={ele.value}
                                            >
                                                {ele.label}
                                            </Option>
                                        );
                                    })}
                                </Select>
                            </li>
                        );
                    })}
                    <li
                        style={{
                            float: "left",
                            marginRight: 20
                        }}
                    >
                        <Button type="primary" onClick={this.handleSearch}>
                            查询
                        </Button>
                    </li>
                    <li
                        style={{
                            float: "right",
                            marginRight: 20
                        }}
                    >
                        <Button type="primary" onClick={this.goUrl}>
                            前往创建合作方页面
                        </Button>
                    </li>
                </ul>
                <Table
                    locale={{ emptyText: "暂无数据" }}
                    rowKey={item => item.id}
                    style={{ marginTop: 30 }}
                    columns={columns}
                    pagination={this.state.pagination}
                    onChange={(page, pageSize) => {
                        this.changePage(page);
                    }}
                    dataSource={this.state.tableData}
                />
                <Modal
                    destroyOnClose={true}
                    title="审核"
                    visible={this.state.visible}
                    // onOk={this.handleOk}
                    onCancel={this.handleCancle}
                    footer={null}
                    okText="确认"
                    cancelText="取消"
                >
                    <div>
                        <FormSummary
                            labelCols={7}
                            ref={this.formRef}
                            formItems={this.state.formItems}
                            formDefaultValue={this.state.formDefaultValue}
                        />
                        <Form
                            style={{
                                marginLeft: "20px",
                                display:
                                    actionType === "edit" ? "block" : "none"
                            }}
                        >
                            <Form.Item
                                {...contractItemLayout}
                                label="上传合同文件"
                            >
                                <Upload
                                    name="filecontent"
                                    action={this.getUploadUrl}
                                    // listType="picture"
                                    defaultFileList={[...fileList]}
                                    onChange={this.handleUploadChange}
                                >
                                    <Button>
                                        <UploadOutlined /> 点击上传
                                    </Button>
                                </Upload>
                            </Form.Item>
                        </Form>
                        <div style={{ textAlign: "center" }}>
                            {this.getStatusBtns()}
                        </div>
                    </div>
                </Modal>
                <Modal
                    destroyOnClose={true}
                    title={
                        currentStatus === AuditStatusDefault
                            ? "通过处理"
                            : "可结算处理"
                    }
                    visible={this.state.pastVisible}
                    onCancel={this.handlePastCancle}
                    onOk={this.handlePastOk}
                    okText="确认"
                    cancelText="取消"
                >
                    <Form>
                        <Form.Item {...formItemLayout} label="是否已有相应渠道">
                            <Radio.Group onChange={this.onRadioChange} defaultValue={false}>
                                <Radio value={true}>是</Radio>
                                <Radio value={false}>否</Radio>
                            </Radio.Group>
                        </Form.Item>
                        <Form.Item
                            {...formItemLayout}
                            label="一级渠道"
                            style={{
                                display:
                                    currentStatus === AuditStatusDefault
                                        ? "block"
                                        : "none"
                            }}
                        >
                            {/* placeholder="请选一级渠道" */}
                            <Select
                                showSearch
                                onChange={this.handleChannelChange}
                                optionFilterProp="children"
                            >
                                {channels.map(item => {
                                    return (
                                        <Option
                                            key={item.value}
                                            value={item.value}
                                        >
                                            {item.label}
                                        </Option>
                                    );
                                })}
                            </Select>
                        </Form.Item>
                        <Form.Item {...formItemLayout} label="二级渠道" style={{ display: isNewCreateChannel ? "block" : "none" }}>
                            <Select
                                showSearch
                                placeholder="请选二级渠道"
                                onChange={this.handleSecondChannelChange}
                                optionFilterProp="children"
                                value={secondChannelId}
                            >
                                {secondChannels.map(item => {
                                    return (
                                        <Option
                                            key={item.id}
                                            value={item.id}
                                        >
                                            {item.name}
                                        </Option>
                                    );
                                })}
                            </Select>
                        </Form.Item>
                    </Form>
                </Modal>
                <Modal
                    destroyOnClose={true}
                    title="合作配置"
                    visible={configVisible}
                    onCancel={() => {
                        this.setState({ configVisible: false });
                    }}
                    // onOk={() => { this.setState({ configVisible: false }) }}
                    footer={null}
                    width="800px"
                    okText="确认"
                    cancelText="取消"
                >
                    <ConfigForm typeList={typeList} configData={configData} saveCallBack={this.saveCallBack} />
                </Modal>
            </div>
        );
    }
}
